import "./sw-share.module.css";
import { html } from "lit-html";
import { LANGUAGE } from "../../global.ts";
import Strings from "../../../models/Strings.json";

export default (user) => html`
    <div
        id="sw-share"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3 class="text-2xl font-semibold text-orange-500">
                        ${Strings.gift[LANGUAGE]}
                    </h3>
                    <aside>
                        <button
                            title="${Strings.copyall[LANGUAGE]}}"
                            onclick="heartbank.alertAdmin('share/copy-all')"
                            id="sw-share-copy-all"
                            class="mr-3">
                            📑
                        </button>
                        <button
                            title="${Strings.close[LANGUAGE]}"
                            type="button"
                            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                            data-modal-hide="sw-share">
                            <svg
                                class="w-3 h-3"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 14">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                            </svg>
                            <span class="sr-only"
                                >${Strings.close[LANGUAGE]}</span
                            >
                        </button>
                    </aside>
                </div>
                <!-- Modal body -->
                <div class="col-span-2 p-5 pb-10">
                    <p
                        id="sw-share-page"
                        class="mt-4 mb-1 text-xl text-gray-900 dark:text-white max-h-56 overflow-y-auto overflow-x-hidden"></p>
                    <br />
                    <section class="relative">
                        <textarea
                            id="sw-share-selection"
                            onblur="heartbank.alertAdmin('share/type/', this.value)"
                            rows="4"
                            class="block p-2.5 w-full h-40 text-lg text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-600 dark:border-gray-500 placeholder-gray-400 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="${Strings.select[
                                LANGUAGE
                            ]}"></textarea>
                        <button
                            title="${Strings.select7[LANGUAGE]}"
                            onclick="heartbank.alertAdmin('share/paste')"
                            class="absolute -bottom-8 left-2"
                            type="button"
                            id="sw-share-paste">
                            📋
                        </button>
                        <button
                            title="${Strings.select6[LANGUAGE]}"
                            onclick="heartbank.alertAdmin('share/clear')"
                            class="absolute -bottom-8 right-2"
                            type="button"
                            id="sw-share-clear">
                            🗑️
                        </button>
                    </section>
                </div>
                <!-- Modal footer -->
                <div
                    class="flex items-center justify-around p-4 md:p-5 border-t border-gray-200 rounded-b dark:border-gray-600">
                    <button
                        onclick="heartbank.alertAdmin('share/submit')"
                        id="sw-share-submit"
                        type="button"
                        class="text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${Strings.select3[LANGUAGE]}
                    </button>
                    <button
                        onclick="heartbank.alertAdmin('share/copy')"
                        id="sw-share-copy"
                        type="button"
                        class="text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${Strings.select4[LANGUAGE]}
                    </button>
                    <button
                        data-modal-hide="sw-share"
                        class="hidden text-white w-32 bg-theme hover:bg-theme/25 focus:ring-4 focus:outline-none focus:ring-theme/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-theme dark:hover:bg-theme/50 dark:focus:ring-theme/10">
                        ${Strings.select5[LANGUAGE]}
                    </button>
                </div>
            </div>
        </div>
    </div>
`;
